<template>
<div class="chapter">
<div class="inner_page">
<p class="letter1"><a id="page_vii">From: Len.Spinks@jfmayhewoffice.co.uk</a></p><a id="page_vii">
<p class="letter">To: Gina.Almonza@SouthCountiesMagazine.com</p>
<p class="letterb">Subject: Sophie Mayhew Article—Editorial Control Suggestions</p>
<p class="letterb">Dear Gina,</p>
<p class="letterb">Thank you for the draft article on Mrs. Mayhew entitled “Sophie at Home.”</p>
<p class="letter">A few amendments, additions, and deletions to consider then implement.</p>
<p class="order">1. Mrs. Mayhew smiles as she greets me; <span class="strike">warmth is perhaps not a word associated with her, but</span> <span class="underline">her handshake is firm and friendly.</span></p>
<p class="order">2. The reception room is wall-to-wall taste with its cool pastel walls and sumptuous carpet. <span class="strike">The furniture is more reflective of style than comfort. It is all too perfect, suggesting some deliberate artistic composition.</span> !!!!! <span class="underline">The furniture is stylish and beautiful, rather like Mrs. Mayhew herself.</span></p>
<p class="order">3. End the article after “New York,” see below.</p>
</a><p class="order-noind"><a id="page_vii">After the tour of her fabulous house, I ask Mrs. Mayhew over tea what her dream is and she gives me a measured reply: to be by her husband’s side as a support because she has put her dreams with his, which reminds me somewhat sweetly of the lyrics of </a><a id="page_viii">“Fairytale of New York.” <span class="strike">I’m not convinced. There is more to Mrs. Mayhew than as a mere appendage to her super-successful husband, much more I suspect, but sadly I’m not going to get the true answer today.</span></a></p><a id="page_viii">
<p class="letterb">And I think we will go with an alternative title: <span class="underline">The Magnificent Mrs. Mayhew.</span></p>
<p class="letterb">Alliterative and entirely fitting to Sophie, the adjective “Magnificent” has slightly old-fashioned yet fond and glamorous connotations—see: <span class="txit">Magnificent</span> Obsession, The <span class="txit">Magnificent</span> Seven, Those <span class="txit">Magnificent</span> Men in their Flying Machines. It is a word less used these days, and for that reason stands out in the best way.</p>
<p class="letterb">We are good to go once these have been incorporated into your article. Please send amended copy forthwith for final read-through.</p>
<p class="letter">Yours truly,</p>
<p class="letterb">Len Spinks</p>
<p class="letter">Senior Communications Director and Press Officer to John F. Mayhew, Secretary of State for Family Matters.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?69961168